import { render, staticRenderFns } from "./ModeSwitchs.vue?vue&type=template&id=f3bf5ed0&scoped=true&"
import script from "./ModeSwitchs.vue?vue&type=script&lang=js&"
export * from "./ModeSwitchs.vue?vue&type=script&lang=js&"
import style0 from "./ModeSwitchs.vue?vue&type=style&index=0&id=f3bf5ed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf5ed0",
  null
  
)

export default component.exports